import { fetchCardInfo } from './fetchCardInfo'

export default [fetchCardInfo]